/**
 * Modal Live-Update Registry
 *
 * When a modal opens that cares about live group data (e.g. receipt, split-expense),
 * it sets `onGroupUpdate` to a handler that knows how to refresh itself in-place.
 * It clears the handler when it closes.
 *
 * The Data Handler in main.mjs calls `modalRegistry.onGroupUpdate(group)` on every
 * subscription update — without knowing or caring which modal is open.
 */
export const modalRegistry = {
    /** @type {((group: object) => void) | null} */
    onGroupUpdate: null,
    /** @type {HTMLElement | null} Reference to the open Group Settings bottom sheet */
    settingsModal: null
};
